// GENERATED FILE -- do not edit by hand.
// Regenerate with `npm run codegen:stores` (see frontend/package.json).
// Source: agent.app.repository.managed.managed_repository_worktree.ManagedRepositoryWorktree

import { makeObservable, observable } from "mobx";
import { applyJsonPatch, JsonPatchOp } from "@/app_store/rpc/json_patch";
import { AgentTransport, callRpc } from "@/app_store/rpc/rpc";
import { registerEntity, wrapEntity } from "@/app_store/rpc/entity";
import { RepositoryChangeData, RepositoryChangeStore } from "./RepositoryChange.generated";
import { ManagedRepositorySandboxData, ManagedRepositorySandboxStore } from "./ManagedRepositorySandbox.generated";

export interface ManagedRepositoryWorktreeData {
    // Stamped onto every @observable model's dump at runtime (see
    // common._ObservableMixin._serialize_with_tag) -- tells wrapEntity which
    // generated Store class this value belongs to. Never sent by a client.
    _entity_class_name: "ManagedRepositoryWorktree";
    branch: string;
    name: string;
    changes: RepositoryChangeData[];
    sandbox: ManagedRepositorySandboxData;
}

export class ManagedRepositoryWorktreeStore {
    readonly _entity_class_name = "ManagedRepositoryWorktree" as const;
    branch: string;
    name: string;
    changes: RepositoryChangeStore[];
    sandbox: ManagedRepositorySandboxStore;
    private _transport: AgentTransport;
    private _chainPath: string[];

    constructor(data: ManagedRepositoryWorktreeData, transport: AgentTransport, chainPath: string[] = []) {
        this._transport = transport;
        this._chainPath = chainPath;
        this.branch = wrapEntity(data.branch, transport, [...chainPath, "branch"]);
        this.name = wrapEntity(data.name, transport, [...chainPath, "name"]);
        this.changes = wrapEntity(data.changes, transport, [...chainPath, "changes"]);
        this.sandbox = wrapEntity(data.sandbox, transport, [...chainPath, "sandbox"]);
        makeObservable(this, {
            branch: observable,
            name: observable,
            changes: observable,
            sandbox: observable,
        });
    }

    applyPatch(op: JsonPatchOp): void {
        applyJsonPatch(this, op);
    }

    async diff(path: any, a?: any, staged?: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "diff", [path, a, staged], {});
    }

    async merge(message: any): Promise<any> {
        return callRpc(this._transport, this._chainPath, "merge", [message], {});
    }

    async sync(): Promise<any> {
        return callRpc(this._transport, this._chainPath, "sync", [], {});
    }
}

registerEntity("ManagedRepositoryWorktree", ManagedRepositoryWorktreeStore);
